declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

type GTMEvent = {
  event: string;
  [key: string]: any;
};

export const pushToDataLayer = (event: GTMEvent) => {
  window.dataLayer?.push(event);
};
